export const V1_RESET_SEARCH_RESULTS = 'V1_RESET_SEARCH_RESULTS'

export default () => {
  return {
    type: V1_RESET_SEARCH_RESULTS,
  }
}
